import pick from 'lodash/pick';

import { fetchPaypalMerchantSignupStatus } from '../../ducks/paypal.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import {
  updateProfile,
  updateProfileThunk,
} from '../ProfileSettingsPage/ProfileSettingsPage.duck';

export const SET_INITIAL_VALUES = 'app/PayPalMerchantPage/SET_INITIAL_VALUES';
export const SAVE_MERCHANT_REQUEST = 'app/PayPalMerchantPage/SAVE_MERCHANT_REQUEST';
export const SAVE_MERCHANT_SUCCESS = 'app/PayPalMerchantPage/SAVE_MERCHANT_SUCCESS';
export const SAVE_MERCHANT_ERROR = 'app/PayPalMerchantPage/SAVE_MERCHANT_ERROR';

const initialState = {
  merchantSaveInProgress: false,
  merchantSaved: false,
  merchantSaveError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    case SAVE_MERCHANT_REQUEST:
      return { ...state, merchantSaveInProgress: true, merchantSaveError: null };
    case SAVE_MERCHANT_SUCCESS:
      return { ...state, merchantSaveInProgress: false, merchantSaved: true, merchantSaveError: null };
    case SAVE_MERCHANT_ERROR:
      return { ...state, merchantSaveInProgress: false, merchantSaved: false, merchantSaveError: payload };
    default:
      return state;
  }
}

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const saveMerchantRequest = () => ({ type: SAVE_MERCHANT_REQUEST });
const saveMerchantSuccess = () => ({ type: SAVE_MERCHANT_SUCCESS });
const saveMerchantError = error => ({ type: SAVE_MERCHANT_ERROR, payload: error, error: true });

const requestSaveMerchant = merchantId => async dispatch => {
  dispatch(saveMerchantRequest());

  try {
    const resultAction = await dispatch(
      updateProfile({
        publicData: {
          merchantId,
          isPaypalConnected: true,
          paypalMerchantStatusIssue: null,
        },
      })
    );

    if (resultAction?.type === updateProfileThunk.rejected.type) {
      throw resultAction.payload || new Error('Failed to save merchant id');
    }

    dispatch(saveMerchantSuccess());
    await dispatch(fetchCurrentUser({ enforce: true }));
  } catch (e) {
    dispatch(saveMerchantError(storableError(e)));
  }
};

export const loadData = (params, search) => async (dispatch, getState) => {
  const queryParams = parse(search);
  const { merchantId: trackingId, merchantIdInPayPal } = queryParams;

  const isOnboardingReturn = !!trackingId && !!merchantIdInPayPal;

  dispatch(setInitialValues());
  await dispatch(fetchCurrentUser({ enforce: true }));

  const currentUser = getState()?.user?.currentUser;
  const currentUserId = currentUser?.id?.uuid;

  const shouldSaveMerchant = isOnboardingReturn && currentUserId && currentUserId === trackingId;
  if (shouldSaveMerchant) {
    await dispatch(requestSaveMerchant(merchantIdInPayPal));
  }

  const merchantId = getState()?.user?.currentUser?.attributes?.profile?.publicData?.merchantId;
  if (merchantId) {
    await dispatch(fetchPaypalMerchantSignupStatus());
  }

  return null;
};
